<template>
  <transition name="el-fade-in-linear">
    <div class="userInfo">
      <div class="userInfo-title">个人信息</div>
      <div class="userInfo-main">
        <div class="main-avatar">
          <el-upload class="avatar-uploader" :action="action" :show-file-list="false" accept=".jpg,.png,.jpeg"
            :data="uploadData" :before-upload="beforeUpload" :headers="headers" :on-success="onSuccess"
            :on-error="onError">
            <el-image :src="avatarImageUrl" fit="cover">
              <div slot="error" class="image-slot" style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: #f5f7fa;
                  color: #c0c4cc;
                ">
                <div>无图片</div>
              </div>
            </el-image>
          </el-upload>
        </div>
        <div class="main-form">
          <el-form :model="userInfo" :rules="userInfoRules" ref="userInfoRef" label-width="80px" label-position="left">
            <!-- 手机号 -->
            <el-form-item label="账号信息" prop="phone" class="phone-item">
              <el-input v-model="userInfo.phone" disabled></el-input>
              <div class="edit-phone" @click="jumpReviseNumber">去修改</div>
            </el-form-item>
            <!-- 姓名 -->
            <el-form-item label="姓名" prop="teacherName">
              <el-input v-model="userInfo.teacherName"></el-input>
            </el-form-item>
            <!-- 工号 -->
            <el-form-item label="工号" prop="teacherNumber">
              <el-input v-model="userInfo.teacherNumber" disabled></el-input>
            </el-form-item>
            <!-- 职务 -->
            <el-form-item label="职务" prop="teacherNumber">
              <el-input :value="jobListAsString" disabled></el-input>
            </el-form-item>
            <!-- 入职时间 -->
            <el-form-item label="入职时间" prop="entryDate">
              <el-date-picker type="date" placeholder="选择日期" v-model="userInfo.entryDate" value-format="yyyy-MM-dd"
                disabled></el-date-picker>
            </el-form-item>
            <!-- 个人简介 -->
            <el-form-item label="个人简介">
              <el-input type="textarea" show-word-limit maxlength="100" :autosize="{ minRows: 2, maxRows: 8 }"
                v-model="userInfo.resume"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="main-submit">
          <button class="submit" @click="submit">完成</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { baseURL } from "@/api/request";

export default {
  data() {
    return {
      avatarImageUrl: "",
      avatarFile: {},
      userInfo: {
        phone: "",
        teacherName: "",
        teacherNumber: "",
        entryDate: "",
        resume: "",
      },
      userInfoRules: {
        teacherName: [{ required: true, message: "姓名不能为空" }],
        teacherNumber: [{ required: true, message: "工号不能为空" }],
        // entryDate: [
        //   {
        //     required: true,
        //     message: "入职时间不能为空",
        //     trigger: "change",
        //   },
        // ],
      },
      // 上传路径
      action: "",
      // 上传的请求头
      headers: {},
      // 上传携带参数
      uploadData: {},
    };
  },
  computed: {
    jobListAsString() {
      return (this.userInfo?.jobList || []).join(", ");
    }
  },
  created() {
    this.action = `${baseURL}${this.$url.updateTeacherHeadPortraitPC}`;
    // console.log(this.user);
    this.avatarImageUrl = this.user.headPortrait;
    this.userInfo.phone = this.user.phone;
    this.userInfo.teacherName = this.user.teacherName;
    this.userInfo.teacherNumber = this.user.teacherNumber;
    this.userInfo.entryDate = this.user.entryDate;
    this.userInfo.resume = this.user.resume;
    this.userInfo.jobList = JSON.parse(
      window.localStorage.getItem("local_userInfo")
    ).jobList;
  },
  methods: {
    submit() {
      this.$refs.userInfoRef.validate((valid) => {
        if (valid) {
          let { teacherNumber, teacherName, entryDate, resume } = this.userInfo;
          this.post(this.$url.updateTeacherInformationPC, {
            id: this.user.id,
            teacherNumber,
            teacherName,
            entryDate,
            resume,
          })
            .then((res) => {
              // console.log(res); && res.data > 0
              if (res.code == 200) {
                // 更新vuex user
                this.$store
                  .dispatch("user/getInfo")
                  .then((res) => {
                    this.$message.success("修改成功");
                  })
                  .catch((err) => {
                    this.$message.error("获取最新数据失败");
                  });
              } else {
                this.$message.error("修改失败");
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error("修改失败，请稍后重试");
            });
        } else {
          return false;
        }
      });
    },

    // 文件上传前 若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$message.warning("请选择jpg,png,jpeg类型文件");
        return false;
      } else if (!limit) {
        this.$message.warning("上传图片大小不能超过 2MB!");
        return false;
      } else {
        // 请求头 token
        this.headers.bbfAdminTeacherToken = window.localStorage.getItem(
          "bbfAdminTeacherToken"
        );
        // 上传携带参数
        this.uploadData.id = this.user.id;
      }
    },
    // 上传成功
    onSuccess(res, file, fileList) {
      console.log(res);
      if (res.code == 200) {
        // 上传成功后
        // 修改vuex
        // this.$store.commit("user/SET_HEADPORTRAIT", res.msg);
        // 当前页面显示
        // this.avatarImageUrl = res.msg;
        // 更新vuex user
        this.$store
          .dispatch("user/getInfo")
          .then((res) => {
            this.$message.success("修改成功");
          })
          .catch((err) => {
            this.$message.error("获取最新数据失败");
          });
      } else if (res.code == 401 || res.code == 403) {
        // token失效
        this.$message.error("获取用户信息失败，请重新登录");
        this.$store.dispatch("user/resetToken");
        this.$router.replace({
          path: "login",
          query: { redirect: this.$router.currentRoute.fullPath },
        });
      } else {
        return this.$message.error("修改失败");
      }
    },
    // 上传失败
    onError(err, file, fileList) {
      // console.log(err);
      return this.$message.error("上传失败，请稍后再试");
    },
    jumpReviseNumber() {
      this.$router.push("/revisephone");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./userInfo.scss";
</style>
